import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from "@angular/common/http";

import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CredentialService } from "app/services";
import { Observable } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private credentialService: CredentialService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    console.log('Inside the interceptor', request);
    let authReq = request;
    let currentUser = this.credentialService.user;
    
    // Only add Authorization header for internal API requests
    // Skip external APIs like labelary.com
    const isExternalRequest = this.isExternalUrl(request.url);
    
    if (currentUser && currentUser.token != null && !isExternalRequest) {
        // request = request.clone({
        //     headers: request.headers.set('Authorization', `Bearer ` + currentUser.token),
        // });
        authReq = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + currentUser.token)});
    }
    console.log(authReq)
    return next.handle(authReq).do(
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          console.log(err);
          console.log('req url :: ' + request.url);
          if (err.status === 401) {
            this.router.navigate(['user']);
          }
        }
      }
    );
  }

  private isExternalUrl(url: string): boolean {
    // List of external domains that should not receive Authorization headers
    const externalDomains = [
      'api.labelary.com',
      'labelary.com'
    ];
    
    return externalDomains.some(domain => url.includes(domain));
  }
}

export const AuthInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
};


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/interceptors/auth.interceptor.ts